import React from 'react';
import { formatCurrency } from '../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { COLORS } from './sponsorshipConstants';

export const SponsorshipOverviewTab = ({ summary }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card className="card-hover">
      <CardHeader>
        <CardTitle className="font-heading">Expense Breakdown</CardTitle>
        <CardDescription>Distribution by expense type</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          {(summary?.expense_breakdown || []).length > 0 ? (
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={summary?.expense_breakdown || []}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={90}
                  paddingAngle={2}
                  dataKey="value"
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                  labelLine={false}
                >
                  {(summary?.expense_breakdown || []).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => formatCurrency(value)} />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-full flex items-center justify-center text-muted-foreground">
              No expense data yet
            </div>
          )}
        </div>
      </CardContent>
    </Card>

    <Card className="card-hover">
      <CardHeader>
        <CardTitle className="font-heading">Monthly Expenses</CardTitle>
        <CardDescription>Spending trends over time</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-64">
          {(summary?.monthly_trends || []).length > 0 ? (
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={summary?.monthly_trends || []}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                <YAxis tickFormatter={(v) => `${(v / 1000000).toFixed(1)}M`} />
                <Tooltip formatter={(value) => formatCurrency(value)} />
                <Bar dataKey="expenses" fill="#E91E63" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-full flex items-center justify-center text-muted-foreground">
              No trend data yet
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  </div>
);
